'use client';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAppContext } from '@/context/app';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import { Kid } from './kid';
import { Men } from './men';
import { Women } from './women';
import { Faq } from './faq';
export const SizeGuideNew = () => {
  // const className = cn(
  //   "font-oswald-bold text-[18px] lg_leading-[96px]",
  //   "border-b-primary border-t-primary border-l-primary border-r-primary border-[1.5px]",
  //   "lg_border-b-transparent lg_border-t-transparent lg_border-l-transparent lg_border-r-transparent lg_border-[4px]",
  //   "data-[state=active]_border-b-[#DA6950] data-[state=active]_border-t-[#DA6950] data-[state=active]_border-l-[#DA6950] data-[state=active]_border-r-[#DA6950]",
  //   "lg_data-[state=active]_border-b-[#DA6950] lg_data-[state=active]_border-t-transparent lg_data-[state=active]_border-l-transparent lg_data-[state=active]_border-r-[#DA6950]",
  // )

  const className = cn(
    'font-roboto-medium lg_leading-[33px]  text-[18px]',
    'border-white border-b-[3px] text-[#929292]',
    'data-[state=active]_border-[#000] data-[state=active]_text-[#000]',
    'lg_data-[state=active]_border-b-[#000]',
  );
  const divider = 'h-[33px] w-[1px] bg-[#929292] mx-[30px]';
  const [{ isSticky }] = useAppContext();
  const { isMobile } = useIsMobile();
  return (
    <div className='personalContent mx-auto min-h-[1800px] py-[40px] lg_pb-[80px] lg_pt-[60px]'>
      <h1 className='mb-[20px] text-center font-teko-medium text-[30px] font-medium uppercase leading-[40px] lg_mb-[40px] lg_text-left lg_text-[40px]'>
        SIZING GUIDE
      </h1>
      <Tabs
        defaultValue='men'
        className='w-full'
      >
        <div
          className={cn(
            'sticky z-30 border-b-1 border-solid border-transparent border-b-[#ccc] bg-white pb-[20px] pt-[20px] lg_pb-[40px]',
            isSticky ? (isMobile ? 'top-[50px] pb-[20px]' : 'top-[78px] ') : 'top-[0]',
          )}
        >
          <TabsList className=' mx-auto flex h-fit justify-center p-0 lg_justify-start '>
            <TabsTrigger
              value='men'
              className={className}
            >
              Men&apos;s
            </TabsTrigger>
            <div className={divider}></div>
            <TabsTrigger
              value='women'
              className={className}
            >
              Women&apos;s
            </TabsTrigger>
            <div className={divider}></div>
            <TabsTrigger
              value='kids'
              className={className}
            >
              Kids&apos;
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent
          className='mt-0'
          value='men'
        >
          <Men />
        </TabsContent>
        <TabsContent
          className='mt-0'
          value='women'
        >
          <Women />
        </TabsContent>
        <TabsContent
          className='mt-0'
          value='kids'
        >
          <Kid />
        </TabsContent>
      </Tabs>
      <Faq />
    </div>
  );
};
